import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccessUsers, Metrics, NewMetrics } from "../../interfaces/interfaces";
import { getMetricsObj } from "./charts.util";

export interface ChartState {
  cachedMetrics: {
    [x: string]: NewMetrics[];
  };
  cachedMetricsObj: {
    [x: string]: {
      [x: string]: NewMetrics;
    };
  };
  reportCollaborators: {
    [x: string]: AccessUsers[];
  };
  cachedPdfUrls: {
    [x: string]: string;
  };
  dataAlertLabel: string;
  currentAlertChart: string;
}

const INITIAL_STATE = {
  cachedMetrics: {},
  reportCollaborators: {},
  cachedPdfUrls: {},
  dataAlertLabel: null,
  currentAlertChart: null,
  cachedMetricsObj: {},
} as ChartState;

type CachedMetricsPayload = {
  reportId: number;
  chartIdentifier: string;
  metrics: NewMetrics[];
  dataAlertLabel: string;
};

type ReportCollaboratorsPayload = {
  reportId: number;
  collaborators: AccessUsers[];
};

type CachedPdfUrlPayload = {
  reportId: string;
  url: string;
};

type SetCurrentAlertMetricsPayload = {
  dataAlertLabel: string;
  reportId: number;
  chartIdentifier: string;
};

const ChartSlice = createSlice({
  name: "chart",
  initialState: INITIAL_STATE,
  reducers: {
    addCachedMetrics: (state, action: PayloadAction<CachedMetricsPayload>) => {
      let reportId = action.payload.reportId;
      let chartIdentifier = action.payload.chartIdentifier;
      state.cachedMetrics = {
        ...state.cachedMetrics,
        [`${reportId}_${chartIdentifier}`]: action.payload.metrics,
      };
      state.dataAlertLabel = action.payload.dataAlertLabel;
      if (action.payload.metrics && action.payload.metrics.length > 0) {
        state.cachedMetricsObj = {
          ...state.cachedMetricsObj,
          [`${reportId}_${chartIdentifier}`]: getMetricsObj(
            action.payload.metrics
          ),
        };
      }
    },
    addReportCollaborators: (
      state,
      action: PayloadAction<ReportCollaboratorsPayload>
    ) => {
      state.reportCollaborators = {
        ...state.reportCollaborators,
        [`${action.payload.reportId}`]: action.payload.collaborators,
      };
    },
    addCachedPdfUrl: (state, action: PayloadAction<CachedPdfUrlPayload>) => {
      state.cachedPdfUrls[action.payload.reportId] = action.payload.url;
    },
    setCurrentAlertMetrics: (
      state,
      action: PayloadAction<SetCurrentAlertMetricsPayload>
    ) => {
      state.dataAlertLabel = action.payload.dataAlertLabel;
      state.currentAlertChart = `${action.payload.reportId}_${action.payload.chartIdentifier}`;
    },
  },
});

export const {
  addCachedMetrics,
  addReportCollaborators,
  addCachedPdfUrl,
  setCurrentAlertMetrics,
} = ChartSlice.actions;

export const ChartSliceReducer = ChartSlice.reducer;
